export const SET_SITE_CONFIG = 'SET_SITE_CONFIG'
export const SET_CURR_POSITION = 'SET_CURR_POSITION'